import DocumentsIcon from './DocumentsIcon';

export default DocumentsIcon;
